import React, { useState, Fragment } from 'react';
import { useTranslate, ReferenceField } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import MappingsEdit from './MappingsEdit';
import { Drawer, EditButton, TextField } from '~/components';
import { Mapping } from '~/types/Menu';
import { TextField as RaTextField } from '~/components/ra';
import { hasTranslation, Longdash } from '~/utils';
import { usePermissions } from 'react-admin';

const l = (key: string): string => `resources.menu.show.${key}`;

interface Props {
  record: Mapping | null;
  onClose: () => void;
  basePath?: string;
}

const MappingsShow = (props: Props) => {
  const { record, onClose } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const { permissions } = usePermissions();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Fragment>
      <MappingsEdit
        record={record}
        open={open}
        onClose={handleClose}
        closeParent={onClose}
        permissions={permissions}
      />
      <Drawer heading={t('showMapping')} open={!!record} onClose={onClose}>
        {record && (
          <Grid container spacing={2} direction='column'>
            <Grid item xs={12}>
              <ReferenceField
                source='menuId'
                reference='menu'
                link={false}
                addLabel={false}
                {...props}
              >
                <RaTextField
                  source='name'
                  label={t('dynamicMenu')}
                  showLink={`/menu/${record?.menuId}/show`}
                />
              </ReferenceField>
            </Grid>
            <Grid item xs={12}>
              <TextField label={t('channel')}>
                {hasTranslation(`resources.menu.channels.${record.channel}`)
                  ? translate(`resources.menu.channels.${record?.channel}`)
                  : record?.channel}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              {record?.solutionId ? (
                <ReferenceField
                  source='solutionId'
                  reference='solutions'
                  link={false}
                  addLabel={false}
                  {...props}
                >
                  <RaTextField
                    source='name'
                    label={t('solution')}
                    showLink={`/solutions/${record?.solutionId}/show/pricingTables`}
                  />
                </ReferenceField>
              ) : (
                <TextField label={t('solution')}>{Longdash}</TextField>
              )}
            </Grid>
            <Grid item container justify='flex-end'>
              <Grid item>
                <EditButton
                  onClick={handleOpen}
                  disabled={!permissions.includes('dynamicMenu.delete')}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Drawer>
    </Fragment>
  );
};

export default MappingsShow;
